import React, { Component } from 'react';
import ModalHeader from './../../../../../../components/Modal/components/ModalHeader/ModalHeader';
import CompetencyScoreBar from './../../components/CompetencyScoreBar/CompetencyScoreBar';
import CompetencyIcon from './../../components/CompetencyIcon/CompetencyIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReportHelper from '../../../../helpers/ReportHelper';
import Developability from '../../../Developability';
import style from './style/pagedcompetencies.scss';
import {
    InterpretationCompetency
} from "neon-frontend-utils/src/components/Report/components/InterpretationCompetency/InterpretationCompetency";

class PagedCompetencies extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: this.props.competencies.map(({ handle }) => handle),
            active: this.props.active // initial state
        };
    }

    updateActiveCompetency(handle) {
        this.setState({
            active: handle
        });
    }

    componentDidUpdate(prevProps) {

        // a new competency was clicked in the report
        if (prevProps.active !== this.props.active) {
            this.updateActiveCompetency(this.props.active);
        }
    }

    goToPrev(handle) {
        const currentIndex = this.state.options.indexOf(handle);

        this.updateActiveCompetency(currentIndex > 0
            ? this.state.options[currentIndex - 1]
            : this.state.options[this.state.options.length - 1]);
    }

    goToNext(handle) {
        const currentIndex = this.state.options.indexOf(handle);

        this.updateActiveCompetency(currentIndex < this.state.options.length - 1
            ? this.state.options[currentIndex + 1]
            : this.state.options[0]);
    }

    isHybrid(reportData) {
        return reportData?.assessmentType === 'hybrid';
    }

    render() {
        const { competencies, closeCompetencyExtendedModal, i18n, languageId, classes = { pagedCompetenciesContent: '' }, reportData, initials } = this.props;
        const activeCompetency = competencies.filter(competency => competency.handle === this.state.active)[0];

        let commentsForOthers = '';
        let commentsForParticipant = '';
        let interviewQuestions = '';
        let tips = '';

        if (activeCompetency.commentsForOthers && activeCompetency.commentsForOthers.text) {
            commentsForOthers = <section className={ style.pagedCompetenciesBulletList }>
                <h4>{ activeCompetency.commentsForOthers.name }</h4>
                <p dangerouslySetInnerHTML={{ __html: activeCompetency.commentsForOthers.text }}/>
            </section>;
        }

        if (activeCompetency.commentsForParticipant && activeCompetency.commentsForParticipant.text) {
            commentsForParticipant = <section className={ style.pagedCompetenciesBulletList }>
                <h4>{ activeCompetency.commentsForParticipant.name }</h4>
                <p dangerouslySetInnerHTML={{ __html: activeCompetency.commentsForParticipant.text }}/>
            </section>;
        }

        if (activeCompetency.interviewQuestions && activeCompetency.interviewQuestions.text) {
            interviewQuestions = <section className={ style.pagedCompetenciesBulletList }>
                <h4>{ activeCompetency.interviewQuestions.name }</h4>
                <p dangerouslySetInnerHTML={{ __html: activeCompetency.interviewQuestions.text }}/>
            </section>;
        }

        if (activeCompetency.tips && activeCompetency.tips.text) {
            tips = <section className={ style.pagedCompetenciesBulletList }>
                <h4>{ activeCompetency.tips.name }</h4>
                <p dangerouslySetInnerHTML={{ __html: activeCompetency.tips.text }}/>
            </section>;
        }

        return (<React.Fragment>
            <ModalHeader classes={{ modalHeader: style.modalHeader }}>
                <header>
                    <CompetencyIcon handle={ `icon_${activeCompetency.translationKeyName}` } />
                    <section>
                        <span>{ i18n.report_competency_profile_extended_title }</span>
                        <h2>{ ReportHelper.getCompetencyName(activeCompetency, languageId, i18n) }</h2>
                    </section>
                </header>
                <button
                    type="button"
                    onClick={ () => {
                        closeCompetencyExtendedModal('modal_competency_profile_extended');
                    }}
                ><span aria-hidden="true">×</span></button>
            </ModalHeader>
            <div className={ `${style.pagedCompetenciesContent} ${classes.pagedCompetenciesContent}` }>
                <p>
                    { ReportHelper.getCompetencyDefinition(activeCompetency, languageId, i18n) }
                </p>

                { this.isHybrid(reportData)
                    ? <InterpretationCompetency
                        key={1}
                        competency={activeCompetency}
                        languageId={languageId}
                        i18n={i18n}
                        reportData={reportData}
                        saveCompetency={null}
                        saveInterval={0}
                        openInterpretationCompetenciesModal={null}
                        showHeader={false}
                        initials={initials}
                    />
                    : <CompetencyScoreBar competency={ activeCompetency } i18n={ i18n } />
                }

                <section>
                    <div className={style.mainContents}>

                        { commentsForOthers }
                        { commentsForParticipant }
                        { interviewQuestions }
                        { tips }
                    </div>
                    {activeCompetency.developabilityScore && activeCompetency.developabilityLabel
                        ? <div className={style.developability}>
                            <Developability
                                developabilityScore={activeCompetency.developabilityScore}
                                classes={{
                                    root: style.developabilityBadge
                                }}
                            />
                            <div className={style.developabilityText}>
                                <h4>{activeCompetency.developabilityLabel}</h4>
                                {activeCompetency.developabilityDefinition ? <span>: {activeCompetency.developabilityDefinition}</span> : null}
                            </div>
                        </div>
                        : null}
                </section>

            </div>
            <div className={ style.scrollIndicator }/>
            <footer className={ style.pagedCompetenciesFooter }>
                <button
                    className={ !this.state.options.indexOf(activeCompetency.handle) ? 'hidden' : 'action_button modal red' }
                    onClick={ () => {
                        this.goToPrev(activeCompetency.handle);
                    } }
                    disabled={!this.state.options.indexOf(activeCompetency.handle)}
                ><FontAwesomeIcon icon={'arrow-left'}/> { i18n.report_competency_profile_extended_previous_competency }</button>
                <button
                    className={ this.state.options.indexOf(activeCompetency.handle) === this.state.options.length - 1 ? 'hidden' : 'action_button red'}
                    onClick={ () => {
                        this.goToNext(activeCompetency.handle);
                    } }
                    disabled={this.state.options.indexOf(activeCompetency.handle) === this.state.options.length - 1}
                >{ i18n.report_competency_profile_extended_next_competency } <FontAwesomeIcon icon={'arrow-right'}/></button>
            </footer>
        </React.Fragment>);
    }
}

export default PagedCompetencies;
